<template>
    <div id="VehicleGroupList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Asset Group List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAddAssetGroup && !programMode" class="btn btn-primary pull-right" v-bind:to="{name: 'AssetGroupCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    <router-link v-if="programMode" class="btn btn-secondary pull-right" v-bind:to="{name: 'ProgramList'}" > <i class="fp-back"> </i> Back</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-group-list">
                        <data-table-filter-config :moduleName="'assetGroupList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'assetGroupList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listVehicleGroupTable"
                                    mode="remote"
                                    title="Asset Group"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: asset_group_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link v-if="canUpdateAssetGroup" title="Edit Asset Group" class="fp-edit" v-bind:to="{name: 'AssetGroupEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <!-- <router-link v-if="change_setting == true && !programMode" class="btn btn-primary" v-bind:to="{name: 'AssetGroupCopySetting'}" @click.native="addAssetGroupId(change_setting_id)">Copy</router-link> -->
                                        <button v-if="change_setting == true && !programMode" class="btn btn-primary" @click="addAssetGroupId(change_setting_id)">Copy</button>
                                        <button v-if="asset_group_value == true && !programMode" id="deleteVehicleGroupBtn" v-on:click.prevent="VehicleGroupDelete" class="btn btn-primary">Delete</button>
                                        <button v-if="programMode" id="recallBtn" v-on:click.prevent="openProgramModal" class="btn btn-primary">Add Asset To Program</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        <div class="modal fade add-extra-charge-popup" id="programModal" ref="programModal" data-backdrop="static" data-keyboard="false" aria-labelledby="programModal" aria-hidden="true">
                            <div class="modal-dialog modal-md" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="myModal1">Program</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form autocomplete="off" id="SelectDates" class="addinspectionForm">
                                            <div class="form-row row-cols-md-1 row-cols-1">
                                                <div class="col form-group">
                                                    <label class="control-label require">Start Point Date:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY" id="start_point_date" name="start_point_date" v-model="start_point_date" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                                        <label for="start_point_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <div class="field-error">{{start_point_date_error_msg}}</div>
                                                </div>
                                            </div>
                                        </form>
                                        <span class="field-error"> On skip the date trigger point will be set according to unit in service date. </span>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" id="addPorgramAssetBtn" v-on:click="addAssetToProgram('save')">
                                            <i class="fp-submit"></i> Save
                                        </button>
                                        <button type="button" class="btn btn-tertiary" id="cancelProgramAssetBtn" v-on:click="addAssetToProgram('skip')">
                                            <i class="fp-close"></i> Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "VehicleGroupList",
        metaInfo() {
            return {title: "Asset Group List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden:false,
                },
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Year',
                    field: 'year',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"integer",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Active', 'Inactive'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

                {
                    label: 'Type',
                    field: 'vehicle_type_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Manufacturer',
                    field: 'vehicle_manufacturer_code',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Model',
                    field: 'vehicle_model_code',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Estimated Life',
                    field: 'estimated_life',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Estimated Life", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            asset_group_value: false,
            loading:false,
            canUpdateAssetGroup:false,
            canAddAssetGroup:false,
            pageKey:"_asset_group_list_",
            programMode:false,
            start_point_date_error_msg:'',
            start_point_date:'',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
                toolbarPlacement:'bottom',
                widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
                },
            },
            change_setting: true,
            change_setting_id: ''
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_group') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_asset_group') {
                            self.asset_group_value = true;
                        }
                        if (permissions[i].name == 'add_asset_group') {
                            self.canAddAssetGroup = true;
                            self.canUpdateAssetGroup = true;
                        }

                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();

            if (self.$route.query.from && self.$route.query.from == 'program'){
                self.programMode = true;
                self.asset_group_value = true;
            }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listVehicleGroupTable.unselectAllInternal();
            },

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('is_default');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.name || filters.is_default) {
                    this.loadList();
                }
            },*/
            selectionChanged(param) {

                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }

                //Show-hide Change Setting button
                if(param.selectedRows.length == 1) {
                  self.change_setting = true;
                  self.change_setting_id = param.selectedRows[0].id;
                } else {
                  self.change_setting = false;
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/assetgroup/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-group-data-list')
                    }
                });
            },
            VehicleGroupDelete() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Asset Group?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['listVehicleGroupTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listVehicleGroupTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteVehicleGroupBtn").val("Deleting ...");
                      $.ajax({
                        url: process.env.ROOT_API + "/assetgroup/delete",
                        type: "POST",
                        data: 'id=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteVehicleGroupBtn").val("Delete");
                            }, 10000);
                            if (data.status == 'used'){
                                self.$swal('',data.message,'info');
                                return;
                            }
                            self.rows = data.content.row;

                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'asset-group-data-delete')
                        }
                    });

                    } else {
                      console.log("no");
                    }
                });
                // if (confirm('Are you sure that you want to delete this Asset Group? ')) {
                //     self.loading = true;
                //     $("#deleteVehicleGroupBtn").val("Deleting ...");

                // }
            },
            openProgramModal: function(){
                var self = this;
                self.start_point_date_error_msg = '';
                self.start_point_date = '';
                $("#programModal").modal('show');
            },
            addAssetToProgram:function(flag){
                var self = this;

                var data = this.$refs['listVehicleGroupTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listVehicleGroupTable'].selectedRows[i].id)
                }

                var program = self.$route.query.pr;
                var fields = [];
                self.start_point_date_error_msg = '';
                if (flag != 'skip'){
                    if (self.start_point_date == '' || self.start_point_date == null || self.start_point_date == undefined){
                        self.start_point_date_error_msg = 'Date Required';
                        return;
                    }
                }

                fields.push({name:'vehicles',value:JSON.stringify(use)});
                fields.push({name:'program_id',value:program});
                fields.push({name:'from',value:'group'});
                fields.push({name:'start_point_date',value:self.start_point_date});
                fields.push({name:'flag',value:flag});

                if (confirm('Are you sure that you want to add these Asset Group to Program? ')) {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/program-asset/add",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            $("#programModal").modal('hide');
                            setTimeout(function () {
                                $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);

                            if (data.code == '200') {
                                // self.$swal('','Asset Added Successfully','success');
                                $("#recallModal").modal('hide');
                                self.loadList();
                                self.$swal({
                                    title: "",
                                    text: "Asset Added Successfully",
                                    type: "success",
                                    showCancelButton: true,
                                    confirmButtonText: "Ok",
                                    cancelButtonText: "Cancel",
                                    showCloseButton: true,
                                    showLoaderOnConfirm: true
                                }).then(result => {
                                        if (result.value) {
                                                // var url = '&program='+program+'&recallText='+self.recalls.text;
                                                self.$router.push({ name: 'ProgramAssetMapperList', params: { id : program }});

                                        } else if (result.dismiss) {
                                            return;
                                        }
                                });

                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            $("#programModal").modal('hide');
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }

            },
            addAssetGroupId: function(id) {
              localStorage.setItem('asset_group_id', id);
              this.$router.push('/assetgroup/copysetting/');
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/AssetGroupList.vue